import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../../shared/components/RedesignModal/RedesignModal.styles';
import { redesignTheme } from '../../../theme';

const { radius } = redesignTheme;

export const useHelpModalStyles = makeStyles((theme: Theme) => ({
  helpPaper: {
    ...modalPaperStyle,
    display: 'block',
    position: 'relative',
    maxWidth: 606,
    maxHeight: '90vh',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: radius.md,
      maxHeight: '90vh',
      maxWidth: '100%',
    },
  },
  helpConfirmPaper: {
    ...modalPaperStyle,
    display: 'block',
    position: 'relative',
    maxWidth: 606,
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      borderRadius: radius.md,
      maxWidth: '100%',
    },
  },
}));
